<template>
  <div class="fulfillment-check">
    <img
        src="../../../assets/warning-icon.svg"
        style="height: 48px; width: 48px; margin-bottom: 16px;">

    <div class="heading">
      This account requires delayed fulfillment.
    </div>
    <div style="word-break: break-word;">
      <div>
        The neighbor must return the device to us before the new device will be shipped out.
      </div>
    </div>

    <div class="bypass-section">
      <el-tooltip
          :content="userCanBypass() ? 'Bypass will be logged':'Contact a leader for bypass'"
          placement="top">
        <el-checkbox
            :disabled="!userCanBypass()"
            :value="value"
            class="bypass-checkbox"
            @change="handleBypassChange">
          Bypass fulfillment
        </el-checkbox>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters: authGetters } = createNamespacedHelpers("auth");

export default {
  name: "FulfillmentCheck",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...authGetters(["isUser"]),
  },
  methods: {
    userCanBypass() {
      // Allow any user that doesn't have the role "user" to use the toggle
      return !this.isUser;
    },
    handleBypassChange(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped>
.fulfillment-check {
  color: #424242;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
}

.heading {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.4em;
  margin-bottom: 16px;
}

.bypass-section {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #dcdfe6;
}

.bypass-checkbox {
  font-weight: 500;
}
</style>
